module.exports = __webpack_public_path__ + "img/card4.b99e5ee4.png";